import { RiskAppetite } from "@portal/types/robot/IRobotEnums";

export const ShouldCreateAskPortfolio = (riskAppetite: RiskAppetite | null) => {
  if (riskAppetite == null) return false;
  return riskAppetite !== RiskAppetite.Careful;
};
